var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChannelAdSm = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 14,
  viewBox: "0 0 14 14",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M11.31 0C12.797 0 14 3.129 14 6.988s-1.204 6.989-2.69 6.989c-.618 0-1.188-.544-1.643-1.457l-.003.004c-1.466-1.915-3.84-2.679-5.733-2.975l.827 3.09a.996.996 0 0 1-.702 1.222l-.198.054a.997.997 0 0 1-1.22-.708L1.61 9.37a9 9 0 0 0-.611.017A.98.98 0 0 1 0 8.41V5.7c0-.55.455-.988.992-.994 0 0 .13.008.36.01h.19c1.563-.014 6.058-.339 8.238-3.49C10.22.453 10.745 0 11.31 0m-.635 2.822c-.725 0-1.313 1.895-1.313 4.233s.588 4.234 1.313 4.234 1.312-1.896 1.312-4.234-.587-4.233-1.312-4.233"
})));
export default SvgChannelAdSm;